import React from 'react';
import { Message } from '@oneflowab/pomes';
import clsx from 'clsx';

import Checkbox from 'components/checkbox';
import Field from 'components/field';
import TextField, { PasswordField } from 'components/text-field';
import Documents from 'components/icons/documents';
import DocumentsSigned from 'components/icons/documents-signed';
import TermsLink from 'components/terms-link';

import style from './guest-conversion.module.scss';

type GuestConversionModalBodyProps = {
  fullName: string;
  email: string;
  companyName: string;
  isSecondStep?: boolean;
  validateIfChecked: (value: boolean) => boolean;
};

const GuestConversionModalBody: React.FC<GuestConversionModalBodyProps> = ({
  fullName,
  email,
  companyName,
  isSecondStep,
  validateIfChecked,
}) => {
  const guestConversionClasses = clsx(style.GuestConversion, {
    [style.MoveContent]: isSecondStep,
    [style.FadeIn]: !isSecondStep,
  });
  const documentsClasses = clsx(style.DocumentsIcon, {
    [style.DelayedFadeOut]: isSecondStep,
    [style.Hidden]: isSecondStep,
  });
  const documentsSignedClasses = clsx({
    [style.DelayedFadein]: isSecondStep,
    [style.Hidden]: !isSecondStep,
  });
  const paragraphClasses = clsx(style.CompanyNameParagraph, {
    [style.FadingParagraph]: isSecondStep,
  });
  const fieldContainerClasses = clsx(style.FieldContainer, {
    [style.DelayedFadein]: isSecondStep,
  });

  return (
    <div className={guestConversionClasses}>
      <Documents
        width="106"
        height="104"
        className={documentsClasses}
      />
      <DocumentsSigned
        width="106"
        height="104"
        className={documentsSignedClasses}
      />
      <h2 className={style.Heading}>
        <Message
          id="Want to make your own smooth, digital contracts?"
          comment="Heading in the first step of the Guest Conversion signup flow."
        />
      </h2>
      <p>
        <Message
          id="Create a free Oneflow account and be on your way to the future of contracts! 💫"
          comment="Explanatory paragraph in the first step of the Guest Conversion signup flow."
        />
      </p>
      <p className={paragraphClasses}>
        <Message
          id="Your account will be created under the name of {name} at {company}"
          comment="Explanatory paragraph in the final step of the Guest Conversion signup flow."
          values={{
            name: <strong>{fullName}</strong>,
            company: <strong>{companyName}</strong>,
          }}
        />
      </p>
      <div className={fieldContainerClasses}>
        <Field
          name="email"
          label={<Message id="Account email" comment="Input field for the users email" />}
          component={TextField}
          required
          initialValue={email}
          disabled
        />
        <Field
          name="password"
          label={<Message id="Create password" comment="Input field for the users password" />}
          component={PasswordField}
          minLength={12}
          maxLength={72}
          required
        />
        <Field
          name="confirmTerms"
          type="checkbox"
          validate={validateIfChecked}
          label={<TermsLink />}
          component={Checkbox}
          required
        />
      </div>
    </div>
  );
};
export default GuestConversionModalBody;
